import React, { FC } from 'react'
import { Box, Flex } from 'front-end/src/components'
import { BoxProps as ChakraBoxProps } from '@chakra-ui/react'
import { getCustomTheme } from 'front-end/src/components/chakraThemeExtension'
import { brandColors } from 'shared/basicPalette'

type EventSettingsHeaderProps = ChakraBoxProps & {
  icon: React.ReactNode | null
  titleText: string
  afterTitle?: React.ReactNode | string
}
const SPACING_BETWEEN_ITEMS = '8px'

/**
 * Header for the setting in the right row of Event detail
 * @param EventFormSettingHeaderProps
 * @returns
 */
const EventSettingsHeader: FC<EventSettingsHeaderProps> = ({
  icon,
  titleText,
  afterTitle,
  children,
  ...rest
}) => {
  const theme = getCustomTheme()

  return (
    <Flex alignItems="center" mb={SPACING_BETWEEN_ITEMS} flexGrow={1} {...rest}>
      <Flex alignItems="center" flexGrow={1}>
        <Box
          boxSize="18px"
          fontSize="18px"
          lineHeight="18px"
          mr="12px"
          color={brandColors.grey[500]}
        >
          {icon}
        </Box>
        <Box fontSize={theme.fontSizes.md} color={brandColors.grey[700]}>
          {titleText}
          {afterTitle && (
            <Box as="span" ml="8px">
              {afterTitle}
            </Box>
          )}
        </Box>
      </Flex>
      <Flex>{children}</Flex>
    </Flex>
  )
}

const EventSettingsRowContent: FC<ChakraBoxProps & { dataTest?: string }> = ({
  children,
  dataTest,
  ...rest
}) => {
  return (
    <Box mb={SPACING_BETWEEN_ITEMS} data-test={dataTest} {...rest}>
      {children}
    </Box>
  )
}

const EventSettingsDescription: FC<ChakraBoxProps & { text: string }> = ({
  text,
  ...rest
}) => {
  return (
    <Flex
      mb={SPACING_BETWEEN_ITEMS}
      fontSize="12px"
      color={brandColors.grey[500]}
      {...rest}
    >
      {text}
    </Flex>
  )
}

const EventSettingsBlock: FC<ChakraBoxProps> = ({ children, ...rest }) => {
  return (
    <Flex direction="column" mb="8px" {...rest}>
      {children}
    </Flex>
  )
}

export {
  EventSettingsHeader,
  EventSettingsRowContent,
  EventSettingsBlock,
  EventSettingsDescription
}
